'use strict'
var moment = require('moment'),
    _ = require('lodash');

function _transformDateResponse(content) {
    var arr = content.split(/\n/),
        obj = {},
        datesArr = [],
        current,
        i;

    for (i = 0; i < arr.length; i++) {
        if (arr[i][0] == '/' ||
            _.isNaN(parseInt(arr[i]))) {
            continue;
        }

        if (!(arr[i].indexOf('-') > -1)) {
            current = parseInt(arr[i], 10);
            obj[current] = [];
        } else {
            obj[current].push(
                _getDates(
                    moment(arr[i].split('-')[0], 'DD.MM.YY').format('YYYY-MM-DD'),
                    moment(arr[i].split('-')[1], 'DD.MM.YY').format('YYYY-MM-DD')
                )
            );
        }
    }

    return obj;
}

function _getDates(startDate, stopDate) {
    var currentDate, dateArray;
    dateArray = [];
    currentDate = moment(startDate, 'YYYY-MM-DD');
    while (currentDate.diff(moment(stopDate, 'YYYY-MM-DD'))) {
        dateArray.push(currentDate.format('YYYY-MM-DD'));
        currentDate = currentDate.add(1, 'days');
    }
    dateArray.push('|');
    return dateArray;
}

module.exports = _transformDateResponse;


// WEBPACK FOOTER //
// ./src/prepareBookingData.js